import API from "../axiosConfig";

const BASE_URL = "role-permissions";

/**
 * Assign multiple permissions to a role (replaces existing assignments)
 */
export const assignPermissions = async (roleId, permissionIds) => {
  try {
    const response = await API.post(`${BASE_URL}/assign`, {
      role_id: roleId,
      permission_ids: permissionIds,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
